import { Typography } from "@mui/material";
import styled from "styled-components";

export const Label = styled(Typography)`
    color: #BFBFBF;
`;

export const Value = styled(Typography)``;

export default { Label, Value };